import { useContext } from 'react';
import { UsageContext } from '../contexts/UsageContext';

/**
 * Custom hook for accessing usage data from UsageContext
 *
 * Provides access to the shared usage data for all products.
 * Must be used within a UsageProvider.
 *
 * @throws Error if used outside of UsageProvider
 *
 * @returns UsageContextValue with usage data and helper functions
 *
 * @example
 * const { getUsageForProduct, loading, refresh } = useUsage();
 * const lessonPlanUsage = getUsageForProduct('lesson_plan');
 *
 * if (lessonPlanUsage?.can_use) {
 *   // User can generate lesson plans
 * }
 */
export const useUsage = () => {
  const context = useContext(UsageContext);

  if (context === undefined) {
    throw new Error('useUsage must be used within a UsageProvider');
  }

  return context;
};
